import zenObservable from 'zen-observable';
export var Observable = zenObservable;
//# sourceMappingURL=zenObservable.js.map


//////////////////
// WEBPACK FOOTER
// ./~/apollo-boost/~/zen-observable-ts/lib/zenObservable.js
// module id = 323
// module chunks = 0